/// 顶部 --- 统计数据
export const totalConfig = {
  "非专营在控": "126",
  "非专营不在控":"200",
  "失控和空置": "74",
  "专营台数": "931",
}

/// ----
export const tableDataArr1 = 
  {
    "product": ["07-01","07-02","07-03","07-04","07-05","07-06","07-07","07-08"],
    "非专营在控": [3,9,5,5,4,6,3,10],
    "非专营不在控": [21,20,13,15,11,14,13,6],
    "失控和空置": [4,3,4,8,15,10,2,3],
    "专营台数": [4,3,4,8,15,10,2,3],
  }
export const tableDataArr2 = 
  {
    "非专营在控": [8,46,20,95,59,46,30,37,0,29,87,63],
    "product": ["北京","西北","豫皖","山东","华中","东北","华北","华东","上海","华南","西南","闽赣"],
    "非专营不在控": [5,202,45,74,29,17,110,14,94,2,58,54],
    "失控和空置": [4,3,4,8,15,10,2,3,13,12,0,0],
    "专营台数": [4,3,4,8,15,10,2,3,13,12,0,0],
  }
export const tableDimensionArr = ["product", "非专营在控", "非专营不在控", "失控和空置","专营台数"]

///
export const modernChartDataArr = [
  {
    "type": "bar",
    "stack": "vistors",
    "barWidth": "70%",
    "label": {
      "normal": {
        "show": true,
        "color": "black",
        "fontSize": 10,
        "position": "inside"
      }
    },
    "animationDuration": 2800,
    "animationEasing": "cubicInOut"
  },
  {
    "type": "bar",
    "stack": "vistors",
    "barWidth": "70%",
    "label": {
      "normal": {
        "show": true,
        "color": "black",
        "fontSize": 10,
        "position": "inside"
      }
    },
    "animationDuration": 2800,
    "animationEasing": "cubicInOut"
  },
  {
    "type": "bar",
    "stack": "vistors",
    "barWidth": "70%",
    "label": {
      "normal": {
        "show": true,
        "color": "black",
        "fontSize": 10,
        "position": "inside"
      }
    },
    "animationDuration": 2800,
    "animationEasing": "cubicInOut"
  },
  {
    "type": "bar",
    "stack": "vistors",
    "barWidth": "70%",
    "label": {
      "normal": {
        "show": true,
        "color": "black",
        "fontSize": 10,
        "position": "inside"
      }
    },
    "animationDuration": 2800,
    "animationEasing": "cubicInOut"
  },
]





// WEBPACK FOOTER //
// ./src/components/kpi/config/TwentyBox.js